export default Object.freeze([
    'lithium',
    'tracer',
    'other',
]);
